import { call, put, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import actions from 'actions'
import api from 'services'

import { fetchData, fetchEntity } from 'utils/sagas'
import { getEventGroupDeals, getEventGroupSellableItems } from 'selectors/event-group'
import {
  getCreatedSellableItems,
  getUpdatedSellableItems,
  getDeletedSellableItems,
  getCreatedDeals,
  getDeletedDeals,
  getSellableItem,
  getDealStartTime,
} from 'selectors/grid'
import { getCurrentPartnerId } from 'selectors/settings'
import { toISOString } from 'utils/datetime'
import { getEventUrl } from 'utils/urls'

const {
  createSellableItem,
  updateSellableItem,
  deleteSellableItem,
  createDeal,
  deleteDeal,
  eventGroup,
  eventGroupDeals,
  eventGroupSellableItems,
  eventGroupSellableItemGroups,
} = actions

const fetchEventGroup = fetchEntity.bind(null, eventGroup, api.fetchEventGroup)
const fetchEventGroupDeals = fetchEntity.bind(null, eventGroupDeals, api.fetchEventGroupDeals)
const fetchEventGroupSellableItems = fetchEntity.bind(
  null,
  eventGroupSellableItems,
  api.fetchEventGroupSellableItems,
)
const fetchEventGroupSellableItemGroups = fetchEntity.bind(
  null,
  eventGroupSellableItemGroups,
  api.fetchEventGroupSellableItemGroups
  )

const createSellableItemFn = fetchData.bind(null, createSellableItem, api.createSellableItem)
const updateSellableItemFn = fetchData.bind(null, updateSellableItem, api.updateSellableItem)
const deleteSellableItemFn = fetchData.bind(null, deleteSellableItem, api.deleteSellableItem)
const createDealFn = fetchData.bind(null, createDeal, api.createDeal)
const deleteDealFn = fetchData.bind(null, deleteDeal, api.deleteDeal)

export function* gridLoadEventGroup({ eventGroupId }) {
  yield call(fetchEventGroup, eventGroupId)
  yield call(fetchEventGroupDeals, eventGroupId)
  yield call(fetchEventGroupSellableItems, eventGroupId)
  yield call(fetchEventGroupSellableItemGroups, eventGroupId)

  const deals = yield select(getEventGroupDeals(eventGroupId))
  const sellableItems = yield select(getEventGroupSellableItems(eventGroupId))
  yield put(actions.gridLoadEventGroupData(deals, sellableItems))
}

export function* gridSave({ eventGroupId }) {
  // Sellable items
  const createdSellableItems = yield select(getCreatedSellableItems)
  const updatedSellableItems = yield select(getUpdatedSellableItems)
  const deletedSellableItems = yield select(getDeletedSellableItems)

  for (const sellableItem of createdSellableItems) {
    yield call(createSellableItemFn, sellableItem.id, eventGroupId, sellableItem.toJS())
  }

  for (const sellableItem of updatedSellableItems) {
    yield call(updateSellableItemFn, sellableItem.serverId, sellableItem.toJS())
  }

  for (const sellableItem of deletedSellableItems) {
    yield call(deleteSellableItemFn, sellableItem.serverId)
  }

  // Deals
  const createdDeals = yield select(getCreatedDeals)
  const deletedDeals = yield select(getDeletedDeals)

  for (const deal of createdDeals) {
    const sellableItem = yield select(getSellableItem(deal.sellableItemId))
    const dealStartTime = yield select(getDealStartTime(deal.id))
    const dealData = {
      sellableItem: sellableItem.serverId,
      ticketCount: sellableItem.quantity,
      availableTickets: sellableItem.quantity,
      startTime: toISOString(dealStartTime),
      ticketIncrement: sellableItem.ticketIncrement,
    }
    yield call(createDealFn, eventGroupId, dealData)
  }

  for (const deal of deletedDeals) {
    yield call(deleteDealFn, deal.serverId)
  }

  const partnerId = parseInt(yield select(getCurrentPartnerId), 10)
  yield put(push(getEventUrl(partnerId, eventGroupId)))
}

export function* gridCancel({ eventGroupId }) {
  const partnerId = parseInt(yield select(getCurrentPartnerId), 10)
  yield put(push(getEventUrl(partnerId, eventGroupId)))
}



/** WEBPACK FOOTER **
 ** ./src/sagas/grid/grid-sagas.js
 **/